function set_popup_cookie_expires(){
    if (popup_cookie_expires == 0) {
        Cookies.set('popup_' + popup_uniqid, 1,);
    } else {
        Cookies.set('popup_' + popup_uniqid, 1, {expires: popup_cookie_expires});
    }
}

(function ($, window) {
    $(function () {
        var $window = $(window);
        var fancybox_touch = $window.width() <= 992 ? true : false;

        // Scliceview current link color
        $("#sliceview [href]").each(function () {
            if (this.href == window.location.href) {
                $(this).addClass("active");
            }
        });

        // Fancybox
        $('[data-fancybox]').fancybox({
            buttons: [
                "close"
            ],
            touch: fancybox_touch
        });

        if(typeof show_popup !== 'undefined'){
            var popupTimeShow = setTimeout(function(){
                $.fancybox.open({
                    src  : '#popup',
                    type : 'inline',
                    baseClass : 'popup',
                    touch: false
                });
                set_popup_cookie_expires();
                $(document).off('mouseleave.initpopupexit');
            }, popup_delay * 1000);

            if(popup_show_on_exit){
                $(document).on('mouseleave.initpopupexit', function () {
                    $.fancybox.open({
                        src  : '#popup',
                        type : 'inline',
                        baseClass : 'popup',
                        touch: false
                    });
                    set_popup_cookie_expires();
                    clearTimeout(popupTimeShow);
                    $(document).off('mouseleave.initpopupexit');
                });
            }
        }

        // Custom select
        $('select:not([multiple]):not(.js-change-content)').select2({
            minimumResultsForSearch: Infinity,
            placeholder: "Pasirinkite"
        });

        // Toggle target selector
        $('.js-toggle-target').on('click', function (e) {
            $($(this).data('target')).slideToggle(500);
            e.preventDefault();
        });

        // Toggle favorites
        $('.c-trip__favorites').on('click', function (e) {
            $(this).toggleClass('h-is-active');
            e.preventDefault();
        });

        // Category menu in blog
        $('.c-category-menu__current').on('click', function (e) {
            var $this = $(this),
                $toggleTarget = $($this.parent()),
                $clickSafeElements = $toggleTarget.add($this);

            $(document).on('click', function eventHadler(event) {
                if (!$(event.target).closest($clickSafeElements).length) {
                    $toggleTarget.removeClass('h-is-active');
                    $(document).off('click', eventHadler);
                }
            });

            $toggleTarget.toggleClass('h-is-active');
            e.preventDefault();
        });

        // Slide to target
        var slideOffset = 0;

        if ($(window).outerWidth() < 993) {
            slideOffset = 87;
        }

        $('.js-scroll-to').on('click', function (e) {
            var $this = $(this);

            $('html, body').animate({
                scrollTop: $($this.data('target')).offset().top - slideOffset
            }, 600);

            e.preventDefault();
        });

        $('a[href*="#"]')
            .not('[href="#"]')
            .not('[href="#0"]')
            .not('.step')
            .click(function (event) {
                if (
                    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                    &&
                    location.hostname == this.hostname
                ) {
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    if (target.length) {
                        event.preventDefault();
                        $('html, body').animate({
                            scrollTop: target.offset().top - slideOffset
                        }, 1000);
                    }
                }
            });

        $('.call-modal').fancybox({
            type: 'ajax',
            buttons: [
                "close"
            ],
            touch: fancybox_touch
        });

        $(document).on('click', '.fancybox-content .c-person.call-coach', function (e) {
            var $this = $(this);
            var modalUrl = $this.data('src');

            $.fancybox.close();

            $.fancybox.open(
                {
                    src: modalUrl,
                    type: 'ajax',
                    buttons: [
                        "close"
                    ],
                    touch: fancybox_touch,
                    afterClose: function (){
                        $.fancybox.open(
                            {
                                src: 'modal/coaches',
                                type: 'ajax',
                                buttons: [
                                    "close"
                                ],
                                touch: fancybox_touch
                            }
                        );
                    }
                }
            );

            e.preventDefault();
        });

        $('.js-news-cat-change').on('change', function () {
            $('form.c-list-categories').submit();
        });

        $('form.c-list-categories').submit(function (e) {
            e.preventDefault();
            $this = $(this);

            var url_new = main_url;

            $this.serializeArray().forEach(function (item, index) {
                if (index === 0) {
                    url_new = url_new + '?' + item.name + '=' + item.value;
                } else {
                    url_new = url_new + '&' + item.name + '=' + item.value;
                }
            });

            history.replaceState(null, null, url_new);

            $.post(
                $this.attr('action'),
                $this.serialize())
                .done(function (data) {
                    $('.news-list-ajax').html(data);
                });

            return false;
        });

        $('.c-list-filters select').on('change', function () {
            $('form.c-list-filters').submit();
        });

        $('form.c-list-filters').submit(function (e) {
            e.preventDefault();
            $this = $(this);

            var url_new = main_url;

            $this.serializeArray().forEach(function (item, index) {
                if (index === 0) {
                    url_new = url_new + '?' + item.name + '=' + item.value;
                } else {
                    url_new = url_new + '&' + item.name + '=' + item.value;
                }
            });

            history.replaceState(null, null, url_new);

            $.post(
                $this.attr('action'),
                $this.serialize())
                .done(function (data) {
                    $('.c-product-list-ajax').html(data);
                });

            return false;
        });

        if (window.location.hash) {
            setTimeout(function() {
                window.scrollTo(0, 0);

                $('html, body').animate({
                    scrollTop: ($(window.location.hash).offset().top - $('.c-site-header').outerHeight()) + 'px'
                }, 1000, 'swing');
            }, 1);
        }

        $(document).on('change', '.daily-menu__day-checkbox input', function () {
            if(!$(this).is(':checked')){
                $(this).closest('.daily-menu').find('.daily-menu__dish__title input').prop("checked", false).removeAttr('checked');
            }
        });

        $(document).on('change', '.daily-menu__dish__title input', function () {
            if($(this).is(':checked')){
                $(this).closest('.daily-menu').find('.daily-menu__day-checkbox input').prop("checked", true).attr('checked', 'checked');
            }
        });
    });
})(jQuery, window);

window.addEventListener('load', function() {
    var body = document.getElementsByTagName('body')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = "https://www.google.com/recaptcha/api.js?render=6LdGTLgqAAAAAN6FRk1FGwMy0LDEZ-d_VjOB1trB";
    body.appendChild(script);
});